'use client';

import classNames from '@sindresorhus/class-names';
import {useCallback} from 'react';

import {OmicronContent} from '@web-catalog/api';

import {YandexBannerAdReservingSpace} from '@web-catalog/components/Ads/Yandex';

import {AppType} from '@web-catalog/types';

import styles from './Banner.module.scss';

type Props = {
  position: number;
  appType: AppType;
  isFirst: boolean;
};

export const Banner = ({appType, position, isFirst}: Props) => {
  const getBlockId = useCallback(
    (omicron: OmicronContent) => {
      const toggleValue =
        appType === 'MAIN'
          ? omicron.WEB_YANDEX_PLACEMENTS_APPS
          : omicron.WEB_YANDEX_PLACEMENTS_GAMES;
      return toggleValue[`placement${position}`];
    },
    [appType, position],
  );
  return (
    <YandexBannerAdReservingSpace
      isEnabled={(config) => !!getBlockId(config)}
      getBlockId={getBlockId}
      bannerContainerClassName={classNames(
        styles.banner,
        isFirst && styles.banner__firstChild,
      )}
      adType="banner_in_featuring"
      placement={
        appType === 'GAMES'
          ? `interesting_games_${position}`
          : `interesting_apps_${position}`
      }
      position={position}
    />
  );
};
